import React from 'react';
import { IProps } from './types';
import _ from 'lodash';

const TravelInsureRules: React.FC<IProps> = (props) => {
  const pcTableRows = [] as JSX.Element[];
  const mobileTableGroups = [] as JSX.Element[];
  let mobileTableGroupRowsTitle: Array<string[]>;

  if (props.ageLimits && props.ageLimits.length > 0) {
    props.ageLimits.forEach((item: string[], itemIndex: number) => {
      // 判斷陣列第一個資料是否為空白 (空白 = 年齡 Range 的標題；不空白 = 標題以及各個金額)
      const isXAxisTitle = !item[0]?.trim();

      // 電腦版 (PC) 渲染 Table
      const pcTableRow = (
        <tr key={itemIndex}>
          {item.map((text: string, textIndex: number) => (
            isXAxisTitle ? (
              <th key={textIndex} className="travel-insure-rules__table-x-title">{text}</th>
            ) : (
              textIndex === 0 ? (
                <th key={textIndex} className="travel-insure-rules__table-y-title">{text}</th>
              ) : (
                <td key={textIndex}>{text}</td>
              )
            )
          ))}
        </tr>
      );
      pcTableRows.push(pcTableRow);

      // 手機版 (Mobile) 渲染 Table
      const mobileTableGroupRowsData = _.chunk(_.drop([...item]), 2);
      if (!isXAxisTitle) {
        // Group (手機版一個險種為一個 Group)
        const mobileTableGroup = (
          <div className="travel-insure-rules__table-mobile-group" key={itemIndex}>
            <div className="travel-insure-rules__table-mobile-group-header">{item[0]}</div>
            {mobileTableGroupRowsData.map((row: string[], rowIndex: number) => (
              <div className="travel-insure-rules__table-mobile-group-row" key={rowIndex}>
                {row.map((text: string, textIndex: number) => (
                  <div className="travel-insure-rules__table-mobile-group-col" key={textIndex}>
                    <span>{mobileTableGroupRowsTitle[rowIndex][textIndex]}</span>
                    <span>{text}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        );
        mobileTableGroups.push(mobileTableGroup);
      } else {
        // 年齡 Range 的標題
        mobileTableGroupRowsTitle = [...mobileTableGroupRowsData];
      }
    });
  }

  return (
    <div className="travel-insure-rules">
      <div className="travel-insure-rules__age-limit-table">
        <div className="travel-insure-rules__age-limit-table-title">投保年齡限制</div>
        {props.ageLimits && props.ageLimits.length > 0 && (
          <>
            {/* Table PC */}
            <div className="travel-insure-rules__table-pc">
              <table>
                <tbody>
                  {pcTableRows}
                </tbody>
              </table>
            </div>
            {/* Table Mobile */}
            <div className="travel-insure-rules__table-mobile">
              {mobileTableGroups}
            </div>
          </>
        )}
        <p>{props.remindText}</p>
      </div>
    </div>
  );
};

export default TravelInsureRules;
